exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* purgecss start ignore */\n.order-item-not-last:not(:last-child) {\n  border-width: 0px;\n  border-bottom-width: 1px;\n  border-style: solid;\n  border-color: var(--primary-text-color-faded-more);\n}\n\n/* purgecss end ignore */\n", ""]);
